import { Component, OnInit, Inject } from '@angular/core';
import { IncassoDistintaModel } from '../../models/brogliacci/incasso-distinta-model';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

export class DistintaIncassoComponentConfig {
  constructor(public incasso:IncassoDistintaModel, public reload:boolean) {

  }
}

@Component({
  selector: 'app-distinta-incasso-component',
  templateUrl: './distinta-incasso-component.html',
  styleUrls: ['./distinta-incasso-component.css']
})

export class DistintaIncassoComponent implements OnInit {
  incassoCorrente:IncassoDistintaModel;
  
  constructor(
    public dialogRef: MdDialogRef<DistintaIncassoComponent>,
    @Inject(MD_DIALOG_DATA) public data: DistintaIncassoComponentConfig) { 
    this.incassoCorrente=data.incasso;
  }

  ngOnInit() {

  }

  chiudi() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/incassi/distinta-incasso-component.ts